import React from "react";
import {PublishedWithChangesOutlined} from "@mui/icons-material";
import Applet from "../../Applet";
import ChangeOrderTable from "../../../../components/Foundation/ChangeOrderTable";
import {hasPrivilege} from "../../../../util/SessionContext";
import {CHANGE_ORDER, allowedMenuOptions} from "../../../../util/changeOrderPrivileges";

// The change order list.
//
// IDENTIFIER FIRST, THEN TITLE. "CO-00014" is what people quote and what an auditor asks for; the
// title is what tells them which change it was. Both, in that order, for the same reason a record
// row shows its object id beside its name.
class ChangeOrderTableApplet extends Applet {

    render() {
        return <ChangeOrderTable applet={this}
                                 pageSize={this.props.PageSize ?? this.state.PageSize}
                                 placement={this.state.Placement}
                                 columns={this.state.Columns}
                                 title="Change orders"
                                 icon={<PublishedWithChangesOutlined/>}
                                 enterpriseComponent={this.getEnterpriseComponent()}
                                 sort={this.state.Sort}
                                 menu={this.state.Menu}
                                 rowHeight={this.state.RowHeight}
                                 enableSearch={true}
                                 enableSort={true}
        />;
    }

    state = {
        Name: "ChangeOrderTableApplet",
        // HIDDEN, NOT DISABLED-WITH-AN-EXPLANATION. Ed's call, 2026-09-06: do not offer a control
        // the caller cannot use. Refresh declares no privilege and so always renders.
        Menu: {options: allowedMenuOptions([
            {displayValue: "Raise change order", value: "Raise Change Order"},
            {displayValue: "Refresh", value: "Refresh"},
        ], {"Raise Change Order": CHANGE_ORDER.RAISE}, hasPrivilege)},
        RowHeight: 48,
        PageSize: {"default": 25, "xs": 5, "sm": 5, "md": 25, "lg": 25, "lx": 25},
        // NEWEST FIRST. A change order list is a working queue, not a reference table: what somebody
        // opens it for is almost always the one they raised most recently.
        //
        // AN ARRAY OF SORT SELECTIONS, NOT A MAP. PlatformTable reads props.sort[i].Identifier and
        // friends; handed an object it finds no length, declares no sorts, and falls back to the
        // framework's RowIdentity ordering -- which most IDOCs do not expose, so the server answers
        // CC-DDE4-JDU7 "Unknown integration component attribute: RowIdentity" and the whole list
        // 500s. PlatformTable's own comment records this being reported against Purchase Orders.
        // Every SortAttribute below must be a tag the IDOC actually carries.
        Sort: [{
            "Identifier": "Raised",
            "Visible": true,
            "Default": true,
            "Options": [{"Direction": "DESC", "SortAttribute": "CreatedDatetime", "DisplayName": "Newest first"}],
        }, {
            "Identifier": "Change Order",
            "Visible": true,
            "Default": false,
            "Options": [{"Direction": "ASC", "SortAttribute": "ChangeOrderID", "DisplayName": "Change order"}],
        }],
        Placement: {
            "xl": [
                {id: "ChangeOrderID"},
                {id: "Title"},
                {id: "ObjectTypeName"},
                {id: "State"},
                {id: "PrimaryPositionName"},
                {id: "CreatedDatetime"},
            ],
        },
        Columns: [
            {id: "ChangeOrderID", width: 150, cellRenderer: "Change Order Id Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "Change Order", hideable: false},
            {id: "Title", width: 340, cellRenderer: "Standard Single Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "Title", hideable: false},
            {id: "ObjectTypeName", width: 200, cellRenderer: "Standard Single Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "Type", hideable: true},
            {id: "State", width: 140, cellRenderer: "Change Order State Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "State", hideable: false},
            {id: "PrimaryPositionName", width: 200, cellRenderer: "Standard Single Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "Owner", hideable: true},
            {id: "CreatedDatetime", width: 180, cellRenderer: "Local Datetime Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "Raised", hideable: true},
        ],
    };
}

export default ChangeOrderTableApplet;
